<template>
    <v-card>
        <v-card-title>
            Select a User to Impersonate
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table multi-sort :loading="loadingUsers" :headers="headers" :search="search" :items="users" class="elevation-1">
            <template v-slot:item.action="{ item }">
                <form :action="appUrl + '/users/impersonate'" method="post">
                    <input type="hidden" :value="csrfToken" name="_token">
                    <input type="hidden" :value="item.id" name="id">
                    <v-btn type="submit" class="ma-2" tile outlined color="primary"><v-icon left>mdi-check</v-icon>Select</v-btn>
                </form>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    export default {
        data: () => ({
            loadingUsers: false,
            appName: process.env.MIX_APP_NAME,
            appUrl: process.env.MIX_APP_URL,
            csrfToken: document.querySelector('meta[name="csrf-token"]').content,
            search: '',
            users: [],
            headers: [
                {'text': 'UIN', value: 'uin'},
                {'text': 'First Name', value: 'first_name'},
                {'text': 'Last Name', value: 'last_name'},
                {'text': 'NetID', value: 'name'},
                { text: 'Action', value: 'action', sortable: false },
            ],
        }),
        props:{
            usersprop:{
                type: Array,
                required: true,
            },
        },
        created(){
            this.users = this.usersprop;
        },
    }
</script>
